<template>

</template>
<script>

  const axios = require('axios').default;

  export default ({
    data() {
      return {
     
      }
    },

    created: function () {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams) {
        this.id = Number(urlParams.get('id'));
        var uri = window.location.toString();
        if (uri.indexOf("?") > 0) {
          var clean_uri = uri.substring(0, uri.indexOf("?"));
          window.history.replaceState({}, document.title, clean_uri);
        }
      }
      this.loadEmail();
    },

    methods: {
      loadEmail() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/EmailAdmitCard?id=' + vm.id)
          .then(function (res) {
            if (res.data.status) {
              alert("Email Sent");

              setTimeout(function () { window.close(); }, 1100);
            }
            endReq();
          });
      }
    }
  })

</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/emailAdmitCard.vue